var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import PostResultItem from '../SearchResultItem/PostResultItem';
import SearchResultItem from '../SearchResultItem/SearchResultItem';
import './SearchResultList.scss';
var SearchResultList = /** @class */ (function (_super) {
    __extends(SearchResultList, _super);
    function SearchResultList(props) {
        return _super.call(this, props) || this;
    }
    SearchResultList.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d;
        if (this.props.resultType == "Posts") {
            return (React.createElement("div", { className: "searchResultList " + this.props.resultType },
                React.createElement("h3", null, this.props.resultType),
                ((_a = this.props.resultsArray) === null || _a === void 0 ? void 0 : _a.length) != 0 ?
                    React.createElement("ul", null, (_b = this.props.resultsArray) === null || _b === void 0 ? void 0 : _b.map(function (result) {
                        return React.createElement(PostResultItem, { key: result.id, result: result });
                    }))
                    :
                        React.createElement("p", null,
                            "No ",
                            this.props.resultType,
                            " found!")));
        }
        return (React.createElement("div", { className: "searchResultList " + this.props.resultType },
            React.createElement("h3", null, this.props.resultType),
            ((_c = this.props.resultsArray) === null || _c === void 0 ? void 0 : _c.length) != 0 ?
                React.createElement("ul", null, (_d = this.props.resultsArray) === null || _d === void 0 ? void 0 : _d.map(function (result) {
                    return React.createElement(SearchResultItem, { key: result.id, result: result, resultType: _this.props.resultType });
                }))
                :
                    React.createElement("p", null,
                        "No ",
                        this.props.resultType,
                        " found!")));
    };
    return SearchResultList;
}(React.Component));
export default SearchResultList;
